import { useIntl } from 'react-intl'

import Typography from '../../../components/Typography/Typography'

import Loader from '../Loader'
import './AppLoader.scss'

const AppLoader = () => {
    const intl = useIntl()

    return (
        <div className="app-loader">
            <Loader />
            <div className={'app-loader-title'}>
                <Typography variant={'sectionHeadline'}>{intl.formatMessage({ id: 'app.loading' })}</Typography>
            </div>
        </div>
    )
}

export default AppLoader
